module.exports = __webpack_public_path__ + "media/images/icon_list-3eb95b6054d76418d500dac6a93db75a.png";